export interface MetaErrorDetail {
  code: number | null;
  subcode: number | null;
  title: string | null;
  message: string | null;
  technical: string | null;
  fbtrace_id: string | null;
  checked: string | null;
}

const text = (value: unknown): string | null =>
  typeof value === "string" && value.trim() ? value.trim() : null;

const num = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isInteger(n) ? n : null;
};

const RATE_LIMIT_CODES = new Set([4, 17, 32, 613, 80000, 80001, 80002, 80003, 80004, 80005, 80006, 80008, 80009, 80014]);

export function metaErrorDetailOf(input: unknown): MetaErrorDetail | null {
  if (!input || typeof input !== "object") return null;
  const bag = input as Record<string, any>;
  const candidates = [
    bag.metaError,
    bag.meta_error,
    bag.details?.meta_error,
    bag.error?.meta_error,
    bag.error?.details?.meta_error,
    bag.response?.data?.meta_error,
    bag.response?.data?.error?.details?.meta_error,
  ];
  for (const c of candidates) {
    if (!c || typeof c !== "object") continue;
    const title = text(c.title);
    const message = text(c.message);
    if (!title && !message) continue;
    return {
      code: num(c.code),
      subcode: num(c.subcode),
      title,
      message,
      technical: text(c.technical),
      fbtrace_id: text(c.fbtrace_id),
      checked: text(c.checked),
    };
  }
  return null;
}

const sentence = (s: string) => (/[.!?)]$/.test(s) ? s : `${s}.`);

export function metaErrorText(detail: MetaErrorDetail): string {
  const { title, message } = detail;
  const said =
    title && message && !message.toLowerCase().startsWith(title.toLowerCase())
      ? `${title}: ${message}`
      : (message ?? title ?? "");
  const parts = [`Meta says: ${sentence(said)}`];
  if (detail.checked) parts.push(sentence(detail.checked));
  if (detail.code != null) {
    parts.push(`(Meta error ${detail.code}${detail.subcode != null ? `, subcode ${detail.subcode}` : ""})`);
  }
  return parts.join(" ");
}

export function isMetaRateLimit(detail: MetaErrorDetail): boolean {
  return detail.code != null && RATE_LIMIT_CODES.has(detail.code);
}
